Array.prototype.remove = function remove() {
  var n = this.length;
  for (var i = 0, l = arguments.length; i < l; i++) {
    for (var j = 0; j < n; j++) {
      if (arguments[i] == this[j]) {
        this.splice(j, 1);
        j--;
        n--;
      }
    }
  }
  return this;
};

// Borrow from https://github.com/epeli/underscore.string/blob/master/lib/underscore.string.js
Array.prototype.toSentence = function(separator, lastSeparator, serial) {
    separator = separator || ', ';
    lastSeparator = lastSeparator || ' and ';
    var a = this.slice(), lastMember = a.pop();

    if (this.length > 2 && serial) {
        lastSeparator = separator.rtrim() + lastSeparator;
    }

    return a.length ? a.join(separator) + lastSeparator + lastMember : lastMember;
};
define("lib/prototype/Array.prototype", function(){});

